import { Box } from '@mui/material';
import { FC } from 'react';
import { baseCardButtonStyling, baseCardStyling } from './styles';

// Define the interface for the component's props
interface IncrementButtonProps {
  text: string;
  onClick: any;
}

// Functional Component using props and state
const IncrementButton: FC<IncrementButtonProps> = ({ text, onClick }) => {
  return (
    <Box
      sx={{
        ...baseCardStyling,
        ...baseCardButtonStyling,
        width: '100%',
        // height: 92,
        paddingTop: 0,
      }}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      {text}
    </Box>
  );
};

export default IncrementButton;
